import { styled } from "@linaria/react";
import { colors, IconSize } from "@/styles/utils/vars";
import { getBoxSize } from "@/ui/Button/helpers";
import { ButtonBox } from "@/ui/Button/StyledButton";
import { cssIcon, getSizeSVG } from "@/ui/Icon";
import { PopoverContainer, StyledPopoverInner } from "@/ui/Popover/StyledPopover";
import { getTypographyBase } from "@/ui/Typography/Typography";
import { VariantActionBarType } from "./ActionBar";
export const ActionBarContainer = /*#__PURE__*/styled('div')({
  name: "ActionBarContainer",
  class: "ActionBarContainer_a1aog6i9"
});
export const Description = /*#__PURE__*/styled('div')({
  name: "Description",
  class: "Description_d92dutn"
});
export const StyledActionBar = /*#__PURE__*/styled('article')({
  name: "StyledActionBar",
  class: "StyledActionBar_skertof",
  vars: {
    "skertof-0": [props => {
      switch (props.variant) {
        case "blue":
          {
            return colors.brand.blueTransparent1;
          }
        case "red":
          {
            return colors.brand.orangeTransparent1;
          }
        default:
          {
            return colors.brand.blueTransparent1;
          }
      }
    }]
  }
});

require("./StyledActionBar.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledActionBar.tsx");